/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskDimensionLabelDetail } from './RiskDimensionLabelDetail';
import {
  RiskDimensionLabelDetailFromJSON,
  RiskDimensionLabelDetailFromJSONTyped,
  RiskDimensionLabelDetailToJSON,
} from './RiskDimensionLabelDetail';
import type { UseCaseName } from './UseCaseName';
import { UseCaseNameFromJSON, UseCaseNameFromJSONTyped, UseCaseNameToJSON } from './UseCaseName';

/**
 *
 * @export
 * @interface RiskLabelCountAll
 */
export interface RiskLabelCountAll {
  /**
   *
   * @type {Array<RiskDimensionLabelDetail>}
   * @memberof RiskLabelCountAll
   */
  labels: Array<RiskDimensionLabelDetail>;
  /**
   *
   * @type {string}
   * @memberof RiskLabelCountAll
   */
  readonly colorOrder: string;
  /**
   *
   * @type {string}
   * @memberof RiskLabelCountAll
   */
  readonly residualRiskLabel: string;
  /**
   *
   * @type {number}
   * @memberof RiskLabelCountAll
   */
  count: number;
  /**
   *
   * @type {Array<UseCaseName>}
   * @memberof RiskLabelCountAll
   */
  useCases: Array<UseCaseName>;
}

/**
 * Check if a given object implements the RiskLabelCountAll interface.
 */
export function instanceOfRiskLabelCountAll(value: object): value is RiskLabelCountAll {
  if (!('labels' in value) || value['labels'] === undefined) return false;
  if (!('colorOrder' in value) || value['colorOrder'] === undefined) return false;
  if (!('residualRiskLabel' in value) || value['residualRiskLabel'] === undefined) return false;
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('useCases' in value) || value['useCases'] === undefined) return false;
  return true;
}

export function RiskLabelCountAllFromJSON(json: any): RiskLabelCountAll {
  return RiskLabelCountAllFromJSONTyped(json, false);
}

export function RiskLabelCountAllFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskLabelCountAll {
  if (json == null) {
    return json;
  }
  return {
    labels: (json['labels'] as Array<any>).map(RiskDimensionLabelDetailFromJSON),
    colorOrder: json['color_order'],
    residualRiskLabel: json['residual_risk_label'],
    count: json['count'],
    useCases: (json['use_cases'] as Array<any>).map(UseCaseNameFromJSON),
  };
}

export function RiskLabelCountAllToJSON(
  value?: Omit<RiskLabelCountAll, 'colorOrder' | 'residualRiskLabel'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    labels: (value['labels'] as Array<any>).map(RiskDimensionLabelDetailToJSON),
    count: value['count'],
    use_cases: (value['useCases'] as Array<any>).map(UseCaseNameToJSON),
  };
}
